<div class="pcl-control-label mat-dialog-title">
  <span>{{ data.message }}</span>
</div>
<mat-nav-list>
  <a mat-list-item (click)="proceed()">
    <span matListItemTitle>Proceed</span>
  </a>

  <a mat-list-item (click)="stay()">
    <span matListItemTitle>Stay</span>
  </a>
</mat-nav-list>
